import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./../home/home.css";

const DoctorDetailPage = ({
  name,
  profileImage = "/Doctorprofile.png",
  accentImage = "/DrinfoH.png",
  specialization,
  experience,
  degrees,
  quote,
  sections,
  favorites,
}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="new-home">
      <Header />
      <main className="doctor-detail-page">
        <section className="doctor-detail-hero">
          <div className="doctor-detail-shell doctor-detail-hero-grid">
            <aside className="doctor-detail-sidebar">
              <div className="doctor-detail-profile-card">
                <div className="stamp-img-wrapper doctor-detail-profile-image">
                  <img src={profileImage} alt={name} />
                </div>
                <div className="doctor-detail-profile-copy">
                  <h1>{name}</h1>
                  <p className="doctor-detail-meta doctor-detail-specialization">
                    {specialization}
                  </p>
                  <p className="doctor-detail-meta">{experience}</p>
                  <p className="doctor-detail-meta">{degrees}</p>
                  <p className="doctor-detail-quote">{quote}</p>
                </div>
              </div>

              <div className="doctor-detail-favorites">
                {favorites.map((item) => (
                  <article className="doctor-detail-favorite-card" key={item.label}>
                    <span className="doctor-detail-favorite-icon" aria-hidden="true">
                      {item.icon}
                    </span>
                    <div>
                      <h2>{item.label}</h2>
                      <p>{item.value}</p>
                    </div>
                  </article>
                ))}
              </div>
            </aside>

            <section className="doctor-detail-main">
              <div className="doctor-detail-accent-art">
                <img src={accentImage} alt="" />
              </div>

              <div className="doctor-detail-sections">
                {sections.map((section) => (
                  <article className="doctor-detail-section" key={section.title}>
                    <h2>{section.title}</h2>
                    <p>{section.body}</p>
                  </article>
                ))}
              </div>
            </section>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default DoctorDetailPage;
